import { render, staticRenderFns } from "./JmMessage.vue?vue&type=template&id=16808b08&scoped=true&"
import script from "./JmMessage.vue?vue&type=script&lang=js&"
export * from "./JmMessage.vue?vue&type=script&lang=js&"
import style0 from "./JmMessage.vue?vue&type=style&index=0&id=16808b08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16808b08",
  null
  
)

export default component.exports